import PlatformNotificationsListItem from './PlatformNotificationsListItem.vue'

export default PlatformNotificationsListItem